import React from "react";
import { connect } from "react-redux";
import Registrazione from "./Registrazione";

const RegistrazionePage = (props) => {
  return (
    <>
      {props.windowBreakpoint === "LARGE" && <Registrazione />}
      {props.windowBreakpoint === "SMALL" && <Registrazione mobile />}
    </>
  );
};

const mapStateToProps = ({ Screen }) => ({
  windowBreakpoint: Screen.breakpoint,
});

export default connect(mapStateToProps)(RegistrazionePage);
